export const DW_GIVING_SCREEN_SHOWN = 'dw_giving_screen_shown';
export const DW_GIVING_MODULE_LOADED = 'dw_giving_module_loaded';
export const DW_GIVING_MODULE_SHOWN = 'dw_giving_module_shown';
export const DW_GIVING_MODULE_PRESSED = 'dw_giving_module_pressed';
export const DW_GIVING_TILE_SHOWN = 'dw_giving_tile_shown';
export const DW_GIVING_DONATE_INTERSTITIAL_SHOWN =
  'dw_giving_donate_interstitial_shown';
export const DW_GIVING_DONATE_INTERSTITIAL_CONTINUE_PRESSED =
  'dw_giving_donate_interstitial_continue_pressed';
export const DW_GIVING_DONATE_INTERSTITIAL_INFO_PRESSED =
  'dw_giving_donate_interstitial_info_pressed';
export const DW_GIVING_PAYPAL_FUND_INFO_SCREEN_SHOWN =
  'dw_giving_paypal_fund_info_screen_shown';
export const DW_GIVING_PAYPAL_FUND_INFO_OK_PRESSED =
  'dw_giving_paypal_fund_info_ok_pressed';
export const DW_GIVING_TILE_PRESSED = 'dw_giving_tile_pressed';
export const DW_GIVING_SEARCH_PRESSED = 'dw_giving_search_pressed';
export const DW_GIVING_SCREEN_SCROLLED = 'dw_giving_screen_scrolled';
export const DW_GIVING_DETAIL_SCREEN_SHOWN = 'dw_giving_detail_screen_shown';
export const DW_GIVING_DETAIL_WEBSITE_PRESSED =
  'dw_giving_detail_website_pressed';
export const DW_GIVING_DETAIL_FAVORITE_PRESSED =
  'dw_giving_detail_favorite_pressed';
export const DW_GIVING_DETAIL_SHARE_PRESSED = 'dw_giving_detail_share_pressed';
export const DW_GIVING_DETAIL_DONATE_PRESSED =
  'dw_giving_detail_donate_pressed';
export const DW_GIVING_DONATE_SETUP_SCREEN_SHOWN =
  'dw_giving_donate_setup_screen_shown';
export const DW_GIVING_DONATE_SETUP_TOOLTIP_PRESSED =
  'dw_giving_donate_setup_tooltip_pressed';
export const DW_GIVING_DONATE_SETUP_TERMS_PRESSED =
  'dw_giving_donate_setup_terms_pressed';
export const DW_GIVING_DONATE_SETUP_COMMENT_PRESSED =
  'dw_giving_donate_setup_comment_pressed';
export const DW_GIVING_DONATE_SETUP_NEXT_PRESSED =
  'dw_giving_donate_setup_next_pressed';
export const DW_GIVING_DONATE_SETUP_DISMISS_PRESSED =
  'dw_giving_donate_setup_dismiss_pressed';
export const DW_GIVING_DONATE_ANONYMOUS_SCREEN_SHOWN =
  'dw_giving_donate_anonymous_screen_shown';
export const DW_GIVING_DONATE_ANONYMOUS_DISMISS_PRESSED =
  'dw_giving_donate_anonymous_dismiss_pressed';
export const DW_GIVING_PAYMENT_SUCCESS_SCREEN_SHOWN =
  'dw_giving_payment_success_screen_shown';
export const DW_GIVING_PAYMENT_SUCCESS_SHARE_PRESSED =
  'dw_giving_payment_success_share_pressed';
export const DW_GIVING_PAYMENT_SUCCESS_DISMISS_PRESSED =
  'dw_giving_payment_success_dismiss_pressed';
export const DW_GIVING_FAVORITE_SUCCESS_SCREEN_SHOWN =
  'dw_giving_favorite_success_screen_shown';
export const DW_GIVING_FAVORITE_SUCCESS_OCCURRED =
  'dw_giving_favorite_success_occurred';
export const DW_GIVING_FAVORITE_ERROR_OCCURRED =
  'dw_giving_favorite_error_occurred';
export const DW_GIVING_FAILED_CUSTOMER_INTERACTION_OCCURRED =
  'dw_giving_failed_customer_interaction_occurred';
export const DW_GIVING_FAILED_CUSTOMER_INTERACTION_RETRY_PRESSED =
  'dw_giving_failed_customer_interaction_retry_pressed';
export const DW_GIVING_FAVORITE_SUCCESS_DISMISS_PRESSED =
  'dw_giving_favorite_success_dismiss_pressed';
export const DW_GIVING_SHARE_SCREEN_SHOWN = 'dw_giving_share_screen_shown';
export const DW_GIVING_SHARE_CHANNEL_PRESSED =
  'dw_giving_share_channel_pressed';
export const DW_GIVING_SHARE_DISMISS_PRESSED =
  'dw_giving_share_dismiss_pressed';
export const DW_GIVING_TILE_LOADED = 'dw_giving_tile_loaded';
export const DW_GIVING_INTRO_FUNDRAISER_SCREEN_SHOWN =
  'dw_giving_intro_fundraiser_screen_shown';
export const DW_GIVING_INTRO_CREATE_FUNDRAISER_INDIVIDUAL_PRESSED =
  'dw_giving_intro_create_fundraiser_individual_pressed';
export const DW_GIVING_INTRO_CREATE_FUNDRAISER_CHARITY_PRESSED =
  'dw_giving_intro_create_fundraiser_charity_pressed';
export const DW_GIVING_INTRO_FUNDRAISER_DISMISS_PRESSED =
  'dw_giving_intro_fundraiser_dismiss_pressed';
export const DW_GIVING_FIND_FUNDRAISER_CHARITY_SCREEN_SHOWN =
  'dw_giving_find_fundraiser_charity_screen_shown';
export const DW_GIVING_FIND_FUNDRAISER_CHARITY_RECOMMENDATION_PRESSED =
  'dw_giving_find_fundraiser_charity_recommendation_pressed';
export const DW_GIVING_FIND_FUNDRAISER_CHARITY_SEARCH_PRESSED =
  'dw_giving_find_fundraiser_charity_search_pressed';
export const DW_GIVING_FIND_FUNDRAISER_CHARITY_DISMISS_PRESSED =
  'dw_giving_find_fundraiser_charity_dismiss_pressed';
export const DW_GIVING_FIND_FUNDRAISER_CHARITY_TERMS_PRESSED =
  'dw_giving_find_fundraiser_charity_terms_pressed';
export const DW_GIVING_BROWSE_FUNDRAISER_CHARITY_SCREEN_SHOWN =
  'dw_giving_browse_fundraiser_charity_screen_shown';
export const DW_GIVING_BROWSE_FUNDRAISER_CHARITY_SEARCH_PRESSED =
  'dw_giving_browse_fundraiser_charity_search_pressed';
export const DW_GIVING_BROWSE_FUNDRAISER_CHARITY_SELECTION_PRESSED =
  'dw_giving_browse_fundraiser_charity_selection_pressed';
export const DW_GIVING_BROWSE_FUNDRAISER_CHARITY_CATEGORY_PRESSED =
  'dw_giving_browse_fundraiser_charity_category_pressed';
export const DW_GIVING_BROWSE_FUNDRAISER_CHARITY_DISMISS_PRESSED =
  'dw_giving_browse_fundraiser_charity_dismiss_pressed';
export const DW_GIVING_CREATE_FUNDRAISER_SCREEN_SHOWN =
  'dw_giving_create_fundraiser_screen_shown';
export const DW_GIVING_CREATE_FUNDRAISER_NEXT_PRESSED =
  'dw_giving_create_fundraiser_next_pressed';
export const DW_GIVING_CREATE_FUNDRAISER_DISMISS_PRESSED =
  'dw_giving_create_fundraiser_dismiss_pressed';
export const DW_GIVING_FUNDRAISER_TELL_STORY_SCREEN_SHOWN =
  'dw_giving_fundraiser_tell_story_screen_shown';
export const DW_GIVING_FUNDRAISER_TELL_STORY_NEXT_PRESSED =
  'dw_giving_fundraiser_tell_story_next_pressed';
export const DW_GIVING_FUNDRAISER_TELL_STORY_DISMISS_PRESSED =
  'dw_giving_fundraiser_tell_story_dismiss_pressed';
export const DW_GIVING_FUNDRAISER_ADD_PHOTO_SCREEN_SHOWN =
  'dw_giving_fundraiser_add_photo_screen_shown';
export const DW_GIVING_FUNDRAISER_ADD_PHOTO_UPLOAD_PRESSED =
  'dw_giving_fundraiser_add_photo_upload_pressed';
export const DW_GIVING_FUNDRAISER_ADD_PHOTO_PUBLISH_PRESSED =
  'dw_giving_fundraiser_add_photo_publish_pressed';
export const DW_GIVING_FUNDRAISER_ADD_PHOTO_PREVIEW_PRESSED =
  'dw_giving_fundraiser_add_photo_preview_pressed';
export const DW_GIVING_FUNDRAISER_ADD_PHOTO_DISMISS_PRESSED =
  'dw_giving_fundraiser_add_photo_dismiss_pressed';
export const DW_GIVING_FUNDRAISER_PHOTO_INTERSTITIAL_SHOWN =
  'dw_giving_fundraiser_photo_interstitial_shown';
export const DW_GIVING_FUNDRAISER_TAKE_PICTURE_PRESSED =
  'dw_giving_fundraiser_take_picture_pressed';
export const DW_GIVING_FUNDRAISER_EXISTING_PHOTO_PRESSED =
  'dw_giving_fundraiser_existing_photo_pressed';
export const DW_GIVING_FUNDRAISER_PHOTO_INTERSTITIAL_DISMISS_PRESSED =
  'dw_giving_fundraiser_photo_interstitial_dismiss_pressed';
export const DW_GIVING_FUNDRAISER_PREVIEW_SCREEN_SHOWN =
  'dw_giving_fundraiser_preview_screen_shown';
export const DW_GIVING_FUNDRAISER_PREVIEW_PUBLISH_PRESSED =
  'dw_giving_fundraiser_preview_publish_pressed';
export const DW_GIVING_FUNDRAISER_PREVIEW_DISMISS_PRESSED =
  'dw_giving_fundraiser_preview_dismiss_pressed';
export const DW_GIVING_FUNDRAISER_PUBLISH_SCREEN_SHOWN =
  'dw_giving_fundraiser_publish_screen_shown';
export const DW_GIVING_FUNDRAISER_PUBLISH_SHARE_PRESSED =
  'dw_giving_fundraiser_publish_share_pressed';
export const DW_GIVING_FUNDRAISER_PUBLISH_VIEW_PRESSED =
  'dw_giving_fundraiser_publish_view_pressed';
export const DW_GIVING_FUNDRAISER_NO_PHOTO_SCREEN_SHOWN =
  'dw_giving_fundraiser_no_photo_screen_shown';
export const DW_GIVING_FUNDRAISER_NO_PHOTO_ADD_PRESSED =
  'dw_giving_fundraiser_no_photo_add_pressed';
export const DW_GIVING_FUNDRAISER_NO_PHOTO_PROCEED_PRESSED =
  'dw_giving_fundraiser_no_photo_proceed_pressed';
export const DW_GIVING_FUNDRAISER_NO_PHOTO_DISMISS_PRESSED =
  'dw_giving_fundraiser_no_photo_dismiss_pressed';
export const DW_GIVING_MY_FUNDRAISER_SCREEN_SHOWN =
  'dw_giving_my_fundraiser_screen_shown';
export const DW_GIVING_MY_FUNDRAISER_CURRENT_MODULE_SHOWN =
  'dw_giving_my_fundraiser_current_module_shown';
export const DW_GIVING_MY_FUNDRAISER_CURRENT_TILE_SHOWN =
  'dw_giving_my_fundraiser_current_tile_shown';
export const DW_GIVING_MY_FUNDRAISER_CURRENT_TILE_PRESSED =
  'dw_giving_my_fundraiser_current_tile_pressed';
export const DW_GIVING_MY_FUNDRAISER_CTA_MODULE_SHOWN =
  'dw_giving_my_fundraiser_cta_module_shown';
export const DW_GIVING_MY_FUNDRAISER_PAST_MODULE_SHOWN =
  'dw_giving_my_fundraiser_past_module_shown';
export const DW_GIVING_MY_FUNDRAISER_PAST_TILE_PRESSED =
  'dw_giving_my_fundraiser_past_tile_pressed';
export const DW_GIVING_MY_FUNDRAISER_DISMISS_PRESSED =
  'dw_giving_my_fundraiser_dismiss_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_SCREEN_SHOWN =
  'dw_giving_manage_fundraiser_screen_shown';
export const DW_GIVING_MANAGE_FUNDRAISER_EDIT_PRESSED =
  'dw_giving_manage_fundraiser_edit_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_SHOW_PRESSED =
  'dw_giving_manage_fundraiser_show_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_SHARE_BUBBLE_PRESSED =
  'dw_giving_manage_fundraiser_share_bubble_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_SHARE_PRESSED =
  'dw_giving_manage_fundraiser_share_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_TRANSFER_PRESSED =
  'dw_giving_manage_fundraiser_transfer_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_PLEDGE_BUBBLE_PRESSED =
  'dw_giving_manage_fundraiser_pledge_bubble_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_PLEDGE_PRESSED =
  'dw_giving_manage_fundraiser_pledge_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_SHOW_MORE_PRESSED =
  'dw_giving_manage_fundraiser_show_more_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_AVAILABLE_TOOLTIP_PRESSED =
  'dw_giving_manage_fundraiser_available_tooltip_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_DISMISS_PRESSED =
  'dw_giving_manage_fundraiser_dismiss_pressed';
export const DW_GIVING_FUNDRAISER_AVAILABLE_AMOUNT_SCREEN_SHOWN =
  'dw_giving_fundraiser_available_amount_screen_shown';
export const DW_GIVING_FUNDRAISER_AVAILABLE_AMOUNT_DISMISS_PRESSED =
  'dw_giving_fundraiser_available_amount_dismiss_pressed';
export const DW_GIVING_EDIT_FUNDRAISER_SCREEN_SHOWN =
  'dw_giving_edit_fundraiser_screen_shown';
export const DW_GIVING_EDIT_FUNDRAISER_DELETE_PRESSED =
  'dw_giving_edit_fundraiser_delete_pressed';
export const DW_GIVING_EDIT_FUNDRAISER_SAVE_PRESSED =
  'dw_giving_edit_fundraiser_save_pressed';
export const DW_GIVING_EDIT_FUNDRAISER_PREVIEW_PRESSED =
  'dw_giving_edit_fundraiser_preview_pressed';
export const DW_GIVING_EDIT_FUNDRAISER_QUIT_PRESSED =
  'dw_giving_edit_fundraiser_quit_pressed';
export const DW_GIVING_EDIT_FUNDRAISER_SUCCESS_OCCURRED =
  'dw_giving_edit_fundraiser_success_occurred';
export const DW_GIVING_QUIT_EDITING_FUNDRAISER_SCREEN_SHOWN =
  'dw_giving_quit_editing_fundraiser_screen_shown';
export const DW_GIVING_QUIT_EDITING_FUNDRAISER_SAVE_PRESSED =
  'dw_giving_quit_editing_fundraiser_save_pressed';
export const DW_GIVING_QUIT_EDITING_FUNDRAISER_WITHOUT_SAVE_PRESSED =
  'dw_giving_quit_editing_fundraiser_without_save_pressed';
export const DW_GIVING_QUIT_EDITING_FUNDRAISER_DISMISS_PRESSED =
  'dw_giving_quit_editing_fundraiser_dismiss_pressed';
export const DW_GIVING_DELETE_FUNDRAISER_SCREEN_SHOWN =
  'dw_giving_delete_fundraiser_screen_shown';
export const DW_GIVING_DELETE_FUNDRAISER_CONFIRM_PRESSED =
  'dw_giving_delete_fundraiser_confirm_pressed';
export const DW_GIVING_DELETE_FUNDRAISER_CANCEL_PRESSED =
  'dw_giving_delete_fundraiser_cancel_pressed';
export const DW_GIVING_FUNDRAISER_TRANSFER_SCREEN_SHOWN =
  'dw_giving_fundraiser_transfer_screen_shown';
export const DW_GIVING_FUNDRAISER_TRANSFER_CONFIRM_PRESSED =
  'dw_giving_fundraiser_transfer_confirm_pressed';
export const DW_GIVING_FUNDRAISER_TRANSFER_DISMISS_PRESSED =
  'dw_giving_fundraiser_transfer_dismiss_pressed';
export const DW_GIVING_FUNDRAISER_TRANSFER_SUCCESS_SCREEN_SHOWN =
  'dw_giving_fundraiser_transfer_success_screen_shown';
export const DW_GIVING_FUNDRAISER_TRANSFER_SUCCESS_WITHDRAW_PRESSED =
  'dw_giving_fundraiser_transfer_success_withdraw_pressed';
export const DW_GIVING_FUNDRAISER_PLEDGE_SCREEN_SHOWN =
  'dw_giving_fundraiser_pledge_screen_shown';
export const DW_GIVING_FUNDRAISER_PLEDGE_CONFIRM_PRESSED =
  'dw_giving_fundraiser_pledge_confirm_pressed';
export const DW_GIVING_FUNDRAISER_PLEDGE_DISMISS_PRESSED =
  'dw_giving_fundraiser_pledge_dismiss_pressed';
export const DW_GIVING_VIEW_FUNDRAISER_SCREEN_SHOWN =
  'dw_giving_view_fundraiser_screen_shown';
export const DW_GIVING_VIEW_FUNDRAISER_SHARE_PRESSED =
  'dw_giving_view_fundraiser_share_pressed';
export const DW_GIVING_VIEW_FUNDRAISER_MANAGE_PRESSED =
  'dw_giving_view_fundraiser_manage_pressed';
export const DW_GIVING_VIEW_FUNDRAISER_DISMISS_PRESSED =
  'dw_giving_view_fundraiser_dismiss_pressed';
export const DW_GIVING_DONATE_SETUP_CARD_PRESSED =
  'dw_giving_donate_setup_card_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_ACTIVITY_TILE_PRESSED =
  'dw_giving_manage_fundraiser_activity_tile_pressed';
export const DW_GIVING_DONATE_SETUP_SHARE_CONTACT_CHECK_PRESSED =
  'dw_giving_donate_setup_share_contact_check_pressed';
export const DW_GIVING_DONATE_SETUP_SHARE_CONTACT_UNCHECK_PRESSED =
  'dw_giving_donate_setup_share_contact_uncheck_pressed';
export const DW_GIVING_VIEW_FUNDRAISER_DONATE_PRESSED =
  'dw_giving_view_fundraiser_donate_pressed';
export const DW_GIVING_MY_FUNDRAISER_PAST_TILE_SHOWN =
  'dw_giving_my_fundraiser_past_tile_shown';
export const DW_GIVING_GUEST_FORM_DONATE_PRESSED =
  'dw_giving_guest_form_donate_pressed';
export const DW_GIVING_GUEST_FORM_DISMISS_PRESSED =
  'dw_giving_guest_form_dismiss_pressed';
export const DW_GIVING_GUEST_FORM_SCREEN_SHOWN =
  'dw_giving_guest_form_screen_shown';
export const DW_GIVING_MEMBER_REVIEW_DISMISS_PRESSED =
  'dw_giving_member_review_dismiss_pressed';
export const DW_GIVING_MANAGE_FUNDRAISER_DONATE_PRESSED =
  'dw_giving_manage_fundraiser_donate_pressed';
export const DW_GIVING_DETAIL_FUNDRAISER_UNAVAILABLE_SCREEN_SHOWN =
  'dw_giving_detail_fundraiser_unavailable_screen_shown';
export const DW_GIVING_DETAIL_FUNDRAISER_UNAVAILABLE_GN_PRESSED =
  'dw_giving_detail_fundraiser_unavailable_gn_pressed';
export const DW_GIVING_PLEDGE_CONFIRMATION_SCREEN_SHOWN =
  'dw_giving_pledge_confirmation_screen_shown';
export const DW_GIVING_PLEDGE_CONFIRMATION_DISMISS_PRESSED =
  'dw_giving_pledge_confirmation_dismiss_pressed';
export const DW_GIVING_QUIT_CREATING_FUNDRAISER_SCREEN_SHOWN =
  'dw_giving_quit_creating_fundraiser_screen_shown';
export const DW_GIVING_QUIT_CREATING_FUNDRAISER_QUIT_PRESSED =
  'dw_giving_quit_creating_fundraiser_quit_pressed';
export const DW_GIVING_QUIT_CREATING_FUNDRAISER_CANCEL_PRESSED =
  'dw_giving_quit_creating_fundraiser_cancel_pressed';
export const DW_GIVING_QUIT_CREATING_FUNDRAISER_DISMISS_PRESSED =
  'dw_giving_quit_creating_fundraiser_dismiss_pressed';
export const DW_GIVING_VIEW_FUNDRAISER_REPORT_PRESSED =
  'dw_giving_view_fundraiser_report_pressed';
export const DW_GIVING_DETAIL_GIVING_FUND_INFO_PRESSED =
  'dw_giving_detail_giving_fund_info_pressed';
export const DW_GIVING_PAYPAL_FUND_INFO_CLOSE_PRESSED =
  'dw_giving_paypal_fund_info_close_pressed';
export const DW_GIVING_MY_FUNDRAISER_CTA_MODULE_PRESSED =
  'dw_giving_my_fundraiser_cta_module_pressed';
export const DW_GIVING_MY_FUNDRAISER_CREATE_NEW_PRESSED =
  'dw_giving_my_fundraiser_create_new_pressed';
export const DW_GIVING_SET_FAVORITE_SCREEN_SHOWN =
  'dw_giving_set_favorite_screen_shown';
export const DW_GIVING_SET_FAVORITE_CONFIRM_PRESSED =
  'dw_giving_set_favorite_confirm_pressed';
export const DW_GIVING_SET_FAVORITE_DISMISS_PRESSED =
  'dw_giving_set_favorite_dismiss_pressed';
export const DW_GIVING_FAVORITE_SUCCESS_DONATE_NOW_PRESSED =
  'dw_giving_favorite_success_donate_now_pressed';
export const DW_GIVING_MY_FUNDRAISER_CREATE_FUNDRAISER_INDIVIDUAL_PRESSED =
  'dw_giving_my_fundraiser_create_fundraiser_individual_pressed';
export const DW_GIVING_MY_FUNDRAISER_CREATE_FUNDRAISER_CHARITY_PRESSED =
  'dw_giving_my_fundraiser_create_fundraiser_charity_pressed';
export const DW_GIVING_INTRO_START_FUNDRAISER_PRESSED =
  'dw_giving_intro_start_fundraiser_pressed';
export const DW_GIVING_MY_FUNDRAISER_GET_STARTED_PRESSED =
  'dw_giving_my_fundraiser_get_started_pressed';
export const DW_GIVING_SEARCH_FILTER_PILL_SHOWN =
  'dw_giving_search_filter_pill_shown';
export const DW_GIVING_SEARCH_FILTER_PILL_CLOSE_PRESSED =
  'dw_giving_search_filter_pill_close_pressed';
export const DW_GIVING_DETAIL_SEARCH_PRESSED =
  'dw_giving_detail_search_pressed';
export const DW_GIVING_DETAIL_BACK_PRESSED = 'dw_giving_detail_back_pressed';
export const DW_GIVING_DETAIL_TERMS_PRESSED = 'dw_giving_detail_terms_pressed';
export const DW_GIVING_DETAIL_FIND_MORE_FUNDRAISERS_PRESSED =
  'dw_giving_detail_find_more_fundraisers_pressed';
export const DW_GIVING_DETAIL_ABOUT_TAB_PRESSED =
  'dw_giving_detail_about_tab_pressed';
export const DW_GIVING_DETAIL_DONATION_TAB_PRESSED =
  'dw_giving_detail_donation_tab_pressed';
export const DW_GIVING_CREATE_FUNDRAISER_AUDIENCE_TOOLTIP_PRESSED =
  'dw_giving_create_fundraiser_audience_tooltip_pressed';
export const DW_GIVING_FUNDRAISER_SELECT_PHOTO_SCREEN_SHOWN =
  'dw_giving_fundraiser_select_photo_screen_shown';
export const DW_GIVING_FUNDRAISER_SELECT_PHOTO_CUSTOMIZE_PRESSED =
  'dw_giving_fundraiser_select_photo_customize_pressed';
export const DW_GIVING_FUNDRAISER_SELECT_PHOTO_TERMS_PRESSED =
  'dw_giving_fundraiser_select_photo_terms_pressed';
export const DW_GIVING_FUNDRAISER_SELECT_PHOTO_PUBLISH_PRESSED =
  'dw_giving_fundraiser_select_photo_publish_pressed';
export const DW_GIVING_FUNDRAISER_SELECT_PHOTO_PREVIEW_PRESSED =
  'dw_giving_fundraiser_select_photo_preview_pressed';
export const DW_GIVING_FUNDRAISER_SELECT_PHOTO_DISMISS_PRESSED =
  'dw_giving_fundraiser_select_photo_dismiss_pressed';
export const DW_GIVING_FUNDRAISER_ADD_PHOTO_TERMS_PRESSED =
  'dw_giving_fundraiser_add_photo_terms_pressed';
export const DW_GIVING_FUNDRAISER_ADD_PHOTO_EDIT_PRESSED =
  'dw_giving_fundraiser_add_photo_edit_pressed';
export const DW_GIVING_EDIT_FUNDRAISER_CHANGE_PHOTO_PRESSED =
  'dw_giving_edit_fundraiser_change_photo_pressed';
export const DW_GIVING_EDIT_FUNDRAISER_REMOVE_PHOTO_PRESSED =
  'dw_giving_edit_fundraiser_remove_photo_pressed';
export const DW_GIVING_MY_FUNDRAISER_OPEN_TAB_PRESSED =
  'dw_giving_my_fundraiser_open_tab_pressed';
export const DW_GIVING_MY_FUNDRAISER_CLOSED_TAB_PRESSED =
  'dw_giving_my_fundraiser_closed_tab_pressed';
export const DW_GIVING_MY_FUNDRAISER_OPEN_SHOW_MORE_PRESSED =
  'dw_giving_my_fundraiser_open_show_more_pressed';
export const DW_GIVING_MY_FUNDRAISER_CLOSED_SHOW_MORE_PRESSED =
  'dw_giving_my_fundraiser_closed_show_more_pressed';
